export default __webpack_public_path__ + "static/media/bg25.a87421bc.jpg";